import moment from 'moment/moment'

export function hoursCount(minTime: string, maxTime: string) {
  const durationHours = moment(maxTime, 'HH:mm').diff(moment(minTime, 'HH:mm'), 'hours', true)

  let duration: number
  let durationDaysResult: number
  let numberOfHours: number

  if (minTime <= '12:00' && maxTime >= '13:00') {
    duration = durationHours - 1
    numberOfHours = durationHours - 1
    durationDaysResult = (durationHours - 1) / 8
  } else if (minTime == '12:30' || maxTime == '12:30') {
    duration = durationHours - 0.5
    numberOfHours = durationHours - 0.5
    durationDaysResult = (durationHours - 0.5) / 8
  } else {
    duration = durationHours
    numberOfHours = durationHours
    durationDaysResult = durationHours / 8
  }

  return {
    duration,
    durationDaysResult,
    numberOfHours,
  }
}
